<div class="discover-right-sidebar col-xs-12 col-md-4">
  <div class="discover-new-container">
    <div class="discover-new-header">
      <h3 class="mode-header">Getting Started Videos</h3>
    </div>
    <ul class="mode-list">
      <li class="discover-new-item" *ngFor="let option of gettingStartedOptions">
        <a href="{{ option.href }}" target="_blank" rel="noopener" attr.data-test="{{ option.testAttribute }}">
          <capra-icon class="video-icon" icon="icon-info-video"></capra-icon><span>{{ option.title }}</span></a
        >
      </li>
    </ul>
  </div>
  <div class="discover-new-container">
    <div class="discover-new-header">
      <h3 class="mode-header">Now Live</h3>
    </div>
    <ul class="mode-list">
      <li *ngFor="let nowLiveLink of nowLiveLinks" class="discover-new-item">
        <a
          href="{{ nowLiveLink.href }}"
          target="_blank"
          rel="noopener"
          attr.data-test="{{ nowLiveLink.testAttribute }}"
        >
          <capra-icon class="live-icon" icon="icon-info-article"></capra-icon>
          <span>{{ nowLiveLink.title }}</span>
        </a>
      </li>
    </ul>
    <div class="discover-new-footer">
      <a href="https://updates.mode.com/" target="_blank" rel="noopener" attr.data-test="release-notes-link"
        >Read Release Notes</a
      >
    </div>
  </div>

  <div class="sidebar-container">
    <h3 class="mode-header">Helpful Links</h3>
    <div *ngFor="let link of helpfulLinks">
      <a href="{{ link.href }}" target="_blank" rel="noopener" attr.data-test="{{ link.testAttribute }}">{{
        link.title
      }}</a>
    </div>
  </div>
</div>
